import { useMemo, useState } from 'react'

import { Input, Text } from '@hhgtech/hhg-components/mantine'
import { CurrentLocation, MapPin, Search } from '@hhgtech/icons/core'
import { Box, BoxProps, Flex, ScrollArea } from '@mantine/core'
import { useIntl } from 'react-intl'

import { normalizeText } from 'utils/htmlHelper'

import useStyles from './index.styles'
import { SelectItemType } from './index.types'
import { CURRENT_LOCATION_KEY } from '../../constants'

type Props = {
  data: SelectItemType[]
  selectedItem?: string
  onClickItem: (v: string) => void
} & BoxProps

export const Select = ({
  selectedItem,
  data = [],
  onClickItem,
  styles,
  classNames,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, theme } = useStyles(undefined, {
    name: 'AirPopulation__Select',
    styles,
    classNames,
  })
  const [searchVal, setSearchVal] = useState('')
  const dataList = useMemo(() => {
    const search = normalizeText(searchVal)
    const filterList = data.filter(
      (i) =>
        i.value === CURRENT_LOCATION_KEY ||
        normalizeText(i.label).includes(normalizeText(search)),
    )
    return filterList.length > 0 ? filterList : data
  }, [searchVal])

  return (
    <Box className={classes.root}>
      <Box className={classes.inputWrapper}>
        <Input
          className={classes.input}
          value={searchVal}
          onChange={setSearchVal}
          placeholder={f({
            id: 'airPopulation.locationSelector.placeholder',
            defaultMessage: 'Search for city',
          })}
          data-event-category="AQI"
          data-event-action="search AQI location"
          data-event-label={searchVal}
        />
        <Search
          size={20}
          color={theme.colors.gray[3]}
          className={classes.searchIcon}
        />
      </Box>
      <ScrollArea.Autosize mah={320} type="auto" scrollbarSize={6}>
        {dataList.map((i, idx) => {
          const isSelected = selectedItem === i.label
          return (
            <Flex
              data-is-current-loc={i.isUseCurrentLocation}
              data-selected={isSelected}
              className={classes.item}
              key={String(idx)}
              align={'center'}
              gap={8}
              onClick={() => !isSelected && onClickItem(i.value)}
              data-event-category="AQI"
              data-event-action="choose AQI location"
              data-event-label={i.label}
            >
              {i.isUseCurrentLocation ? <CurrentLocation /> : <MapPin />}
              <Text size="p2">{i.label}</Text>
            </Flex>
          )
        })}
      </ScrollArea.Autosize>
    </Box>
  )
}
